import { BaseEntity } from '../../../models';
import { TipoClassificacao } from '../../tipo-classificacao';
import { Classificacao } from '../../classificacao';

export class GrupoClassificacaoClassificacao implements BaseEntity {
    readonly id: number;
    idGrupoClassificacao: number;
    idTipoClassificacao: number;
    tipoClassificacao: TipoClassificacao;
    idClassificacao: number;
    classificacao: Classificacao;
    obrigatorio: boolean;

    constructor() {
        this.obrigatorio = true;
    }
}
